<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" sm="6" class="mb-md-0 mb-2">
          <label>Status</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
            placeholder="Select Status.."
          />
        </b-col>
        <b-col cols="12" md="4" sm="6" class="mb-md-0 mb-2">
          <label>Category</label>
          <b-form-select
            :value="categoryFilter"
            @input="(val) => $emit('update:categoryFilter', val)"
            :options="parentCategoryOption"
          ></b-form-select>
        </b-col>
        <b-col cols="12" md="4" sm="6" class="mb-md-0 mb-2">
          <label>Auditor</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="auditorFilter"
            :options="auditorOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:auditorFilter', val)"
            placeholder="Select Auditor.."
          />
        </b-col>
        <b-col cols="12" md="4" sm="6" class="mb-md-0 mb-2">
          <label>Apply Permission</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="applyPermissionFilter"
            :options="applyPermissionOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:applyPermissionFilter', val)"
            placeholder="Select Apply Permission.."
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: (h) => h("feather-icon", { props: { size: "14", icon: "XIcon" } }),
  },
  OpenIndicator: {
    render: (h) =>
      h("feather-icon", {
        props: { size: "15", icon: "ChevronDownIcon" },
        class: "open-indicator",
      }),
  },
});

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    vSelect,
  },
  props: {
    statusFilter: {},
    statusOptions: {
      type: Array,
      required: true,
    },
    categoryFilter: {},
    auditorFilter: {},
    applyPermissionFilter: {},
    parentCategoryOption: {
      required: true,
    },
  },
  data() {
    return {
      auditorOptions: [
        {
          label: "Reporting Manager",
          value: "reporting_manager",
        },
        {
          label: "Admin",
          value: "admin",
        },
        {
          label: "Owner",
          value: "owner",
        },
      ],
      applyPermissionOptions: [
        {
          label: "Employee",
          value: "employee",
        },
        {
          label: "Owner",
          value: "owner",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
